"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportSummaryController = function () {
    function ReportSummaryController() {
        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, ReportSummaryController);
        this.summaryMatrix = [];

        this.$onChanges = function (changesObj) {
            _this.summaryMatrix = _this.listToMatrix(_this.summary, 3);
        };
    }

    (0, _createClass3.default)(ReportSummaryController, [{
        key: "listToMatrix",
        value: function listToMatrix(list, elementsPerSubArray) {
            if (!list) {
                return;
            }

            var matrix = [],
                i,
                k;

            for (i = 0, k = -1; i < list.length; i++) {
                if (i % elementsPerSubArray === 0) {
                    k++;
                    matrix[k] = [];
                }

                matrix[k].push(list[i]);
            }

            return matrix;
        }
    }]);
    return ReportSummaryController;
}();

exports.default = ReportSummaryController;


// WEBPACK FOOTER //
// ./client/app/components/reports/reportSummary/reportSummary.controller.js